import { colorPallet } from 'src/styles/theme/colors';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

export const CalendarWidgetContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  justify-content: center;
  align-items: center;
  @media (max-width: 1320px) {
    grid-template-columns: 1fr 1fr 1fr;
    width: 67.5vw;
  }
  @media (min-resolution: 100dpi) {
    grid-template-columns: ${() => (isMobile ? 'unset' : '1fr 1fr 1fr')};
    width: 67.5vw;
  }
  width: 75vw;
  @media (max-width: 1072px) {
    width: 100%;
    grid-template-columns: 1fr;
    justify-self: center;
    align-self: center;
  }
`;

export const CalendarContainer = styled.div`
  background: ${(props) => props.theme.mainBackgorund};
  display: flex;
  flex-direction: column;
  padding-top: ${() => (isMobile ? '0' : '1rem')};
  padding-bottom: ${() => (isMobile ? '0' : '1rem')};
  padding-right: ${() => (isMobile ? '0' : '1rem')};
  position: relative;
  height: ${() => (isMobile ? '90%' : '100%')};
  @media (max-width: 1072px) {
    grid-template-columns: 1fr;
    padding-top: 0.3rem;
    box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
    ${() => (isMobile ? '0' : '2.5rem')};
  }
`;

export const RequestTimeOffMobile = styled.button`
  background-color: ${colorPallet.richBlue};
  color: #ffffff;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  position: absolute;
  bottom: -1.4rem;
  right: 1.5rem;
  :disabled {
    background-color: ${colorPallet.lightGray};
  }
`;
